import {generateLiveRegion, clearLiveRegion} from './liveRegion';

const loadingButton = (el) => {
    if (!el) {
        return;
    }

    const spinnerTemplate = el.nextElementSibling;
    const spinnerContent = spinnerTemplate.content.cloneNode(true);

    el.classList.add('kinde-is-loading');
    el.textContent = '';
    el.appendChild(spinnerContent);
    el.setAttribute('aria-disabled', 'true');
    generateLiveRegion('formSubmit');
};

const getLoadingButtonText = (el) => {
    const buttonTextEl = el.querySelector('[data-kinde-button-text]');

    if (!buttonTextEl) {
        return;
    }

    return buttonTextEl.textContent;
};

const restoreLoadingButton = (el, originalText) => {
    if (!el) {
        return;
    }

    const spinnerEl = el.querySelector('[data-kinde-form-submit-spinner]');

    if (spinnerEl) {
        spinnerEl.remove();
    }

    const buttonTextEl = document.createElement('span');
    buttonTextEl.className = 'kinde-button-text';
    buttonTextEl.setAttribute('data-kinde-button-text', 'true');
    buttonTextEl.textContent = originalText;

    el.classList.remove('kinde-is-loading');
    el.removeAttribute('aria-disabled');
    el.appendChild(buttonTextEl);
    clearLiveRegion();
};

export {loadingButton, restoreLoadingButton, getLoadingButtonText};
